"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveExpression = void 0;
var lodash_get_1 = __importDefault(require("lodash.get"));
var utils_1 = require("../utils");
var types_1 = require("../types");
var strings_1 = require("./strings");
var numbers_1 = require("./numbers");
var booleans_1 = require("./booleans");
var arrays_1 = require("./arrays");
var objects_1 = require("./objects");
var functions_1 = require("./functions");
var variable_1 = require("./variable");
var functionCall_1 = require("./functionCall");
var find_1 = require("./find");
// Quick type checks, since validation is external and more expensive
var checkRefExpression = function (obj) { return !!obj.$ref; };
var checkResolvedExpression = function (obj) {
    return !!obj.$expression;
};
// get a reference in definitions
// this is populated deeply ie fetching all references inside references
// this below is the limit for circular references depth
var refsLimit = 100;
var populateReferences = function (objectExpression, context, counts) {
    if (counts === void 0) { counts = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var newObject, refPathValue, reference, _a, _b, _i, valueKey, value, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    newObject = objectExpression;
                    if (!!Array.isArray(newObject)) return [3 /*break*/, 3];
                    newObject = __assign({}, newObject);
                    _e.label = 1;
                case 1:
                    if (!newObject.$ref) return [3 /*break*/, 3];
                    return [4 /*yield*/, strings_1.resolveStringExpression(newObject.$ref, context)];
                case 2:
                    refPathValue = _e.sent();
                    counts[refPathValue] = (counts[refPathValue] || 0) + 1;
                    if (counts[refPathValue] > refsLimit) {
                        throw new Error([
                            'Could not populate references in:',
                            JSON.stringify(newObject, null, 2),
                            "\"" + refPathValue + "\" has been referenced more than the referencing limit: " + refsLimit + ".",
                            'Consider factorizing your code differently.'
                        ].join('\n'));
                    }
                    reference = utils_1.deepClone(lodash_get_1.default(context.$definitions, refPathValue));
                    // if the reference value is not an object or array return directly this value
                    if (typeof reference !== 'object') {
                        return [2 /*return*/, reference];
                    }
                    if (Array.isArray(reference)) {
                        // if reference is an array, just replace the object with this array and continue
                        newObject = reference;
                    }
                    else if (reference) {
                        // else if this is a real non null object overlay the retrieved data
                        // while preserving the existing fields
                        // and continue
                        delete newObject.$ref;
                        newObject = __assign(__assign({}, reference), newObject);
                    }
                    return [3 /*break*/, 1];
                case 3:
                    _a = [];
                    for (_b in newObject)
                        _a.push(_b);
                    _i = 0;
                    _e.label = 4;
                case 4:
                    if (!(_i < _a.length)) return [3 /*break*/, 7];
                    valueKey = _a[_i];
                    value = newObject[valueKey];
                    if (!(typeof value === 'object')) return [3 /*break*/, 6];
                    _c = newObject;
                    _d = valueKey;
                    return [4 /*yield*/, populateReferences(value, context, counts)];
                case 5:
                    _c[_d] = _e.sent();
                    _e.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 4];
                case 7: return [2 /*return*/, newObject];
            }
        });
    });
};
// resolve an array of expressions recursively
var parseArray = function (expression, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedArray, _i, expression_1, arrayElement, arrayElementValue;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                parsedArray = [];
                _i = 0, expression_1 = expression;
                _a.label = 1;
            case 1:
                if (!(_i < expression_1.length)) return [3 /*break*/, 4];
                arrayElement = expression_1[_i];
                return [4 /*yield*/, exports.resolveExpression(arrayElement, context)];
            case 2:
                arrayElementValue = _a.sent();
                parsedArray.push(arrayElementValue);
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, parsedArray];
        }
    });
}); };
// resolve an object with expression values recursively
var parseObject = function (expression, context) { return __awaiter(void 0, void 0, void 0, function () {
    var resolvedObject, _a, _b, _i, key, objectPropertyValue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                resolvedObject = {};
                _a = [];
                for (_b in expression)
                    _a.push(_b);
                _i = 0;
                _c.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 4];
                key = _a[_i];
                return [4 /*yield*/, exports.resolveExpression(expression[key], context)];
            case 2:
                objectPropertyValue = _c.sent();
                resolvedObject[key] = objectPropertyValue;
                _c.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, resolvedObject];
        }
    });
}); };
// global expression resolver
var resolveExpression = function (expression, context) { return __awaiter(void 0, void 0, void 0, function () {
    var expressionRefData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (expression == null)
                    return [2 /*return*/, expression];
                if (!(typeof expression === 'object')) return [3 /*break*/, 3];
                if (!checkRefExpression(expression)) return [3 /*break*/, 2];
                return [4 /*yield*/, populateReferences(expression, context)];
            case 1:
                expressionRefData = _a.sent();
                return [2 /*return*/, exports.resolveExpression(expressionRefData, context)];
            case 2:
                if (checkResolvedExpression(expression)) {
                    // $expression is a keyword that indicates that the expression must be resolved as the result of a specific function
                    switch (expression.$expression) {
                        case types_1.ResolvedExpressionType.Join:
                            return [2 /*return*/, strings_1.resolveJoinExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Split:
                            return [2 /*return*/, strings_1.resolveSplitExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Sum:
                            return [2 /*return*/, numbers_1.resolveSumExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Product:
                            return [2 /*return*/, numbers_1.resolveProductExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Inverse:
                            return [2 /*return*/, numbers_1.resolveInverseExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Or:
                            return [2 /*return*/, booleans_1.resolveOrExpression(expression, context)];
                        case types_1.ResolvedExpressionType.And:
                            return [2 /*return*/, booleans_1.resolveAndExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Not:
                            return [2 /*return*/, booleans_1.resolveNotExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Equal:
                            return [2 /*return*/, booleans_1.resolveEqualExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Sorted:
                            return [2 /*return*/, booleans_1.resolveSortedExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Sort:
                            return [2 /*return*/, arrays_1.resolveSortExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Concat:
                            return [2 /*return*/, arrays_1.resolveConcatExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Merge:
                            return [2 /*return*/, objects_1.resolveMergeExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Entries:
                            return [2 /*return*/, objects_1.resolveEntriesExpression(expression, context)];
                        case types_1.ResolvedExpressionType.FunctionDeclaration:
                            return [2 /*return*/, functions_1.resolveFunctionDeclarationExpression(expression, context)];
                        case types_1.ResolvedExpressionType.ExternalFunction:
                            return [2 /*return*/, functions_1.resolveExternalFunctionExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Variable:
                            return [2 /*return*/, variable_1.resolveVariableExpression(expression, context)];
                        case types_1.ResolvedExpressionType.FunctionCall:
                            return [2 /*return*/, functionCall_1.resolveFunctionCallExpression(expression, context)];
                        case types_1.ResolvedExpressionType.Find:
                            return [2 /*return*/, find_1.resolveFindExpression(expression, context)];
                        default:
                            throw new Error("Unhandled expression type: " + expression.$expression);
                    }
                }
                // this is a real object (or array) so we need to resolve it as such, ie recursively
                if (Array.isArray(expression)) {
                    return [2 /*return*/, parseArray(expression, context)];
                }
                return [2 /*return*/, parseObject(expression, context)];
            case 3: return [2 /*return*/, expression];
        }
    });
}); };
exports.resolveExpression = resolveExpression;
//# sourceMappingURL=index.js.map